import firebaseApp from "../firebase";

export const get_Fermes = ({ commit }) => {
  firebaseApp.ref("Sites").once("value", (snap) => {
    let Farm_List = [];
    snap.forEach((doc) => {
      Farm_List.push(doc.val().designation);
    });
    commit("set_Farm_List", Farm_List);
  });
};

export const get_Vehicules = ({ commit }) => {
  firebaseApp.ref("Véhicule").once("value", (snap) => {
    let véhicule_list = [];
    snap.forEach((doc) => {
      véhicule_list.push(doc.val().Matricule);
    });
    commit("set_Véhicule_list", véhicule_list);
  });
};

export const get_Employes = ({ commit }) => {
  firebaseApp.ref("Employé").once("value", (snap) => {
    let employés_Table = [];
    snap.forEach((doc) => {
      employés_Table.push({
        id: doc.val().Matricule,
        nom_prenom: doc.val().Nom_prénom,
        cin: doc.val().Cin,
        id_nom_cin: `${doc.val().Matricule} ${doc.val().Nom_prénom} ${
          doc.val().Cin
        }`,
      });
    });
    commit("set_employés_Table", employés_Table);
  });
};

export const get_taches = ({ commit }) => {
  firebaseApp.ref("Taches").once("value", (snap) => {
    let tache_list = [];
    snap.forEach((doc) => {
      tache_list.push({
        id: doc.val().code,
        text: doc.val().designation,
        repartition: doc.val().repartition,
      });
    });
    commit("set_tache_list", tache_list);
  });
};
export const get_Variété = ({ commit }) => {
  firebaseApp.ref("Variété").once("value", (snap) => {
    let Variété_list = [];
    snap.forEach((doc) => {
      Variété_list.push({
        id: doc.val().Code,
        text: doc.val().Désignation,
        Nbr_jours: doc.val().Nbr_jours,
      });
    });
    commit("set_Variété_list", Variété_list);
  });
};

export const get_parcelle = ({ commit }) => {
  firebaseApp.ref("Parcelle").once("value", (snap) => {
    let parcelle_list = [];
    snap.forEach((doc) => {
      parcelle_list.push({
        id: doc.val().id,
        code: doc.val().code,
        ferme: doc.val().ferme,
      });
    });
    commit("set_parcelle_list", parcelle_list);
  });
};

export const set_Compte = ({ commit }, compte) => {
  commit("set_Compte", compte);
};
export const set_token = ({ commit }, token) => {
  commit("set_token", token);
};
